import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { AuthLayout, PasswordInput, FieldLabel, FormError } from "@/components/auth/AuthLayout";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Signup() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.password !== f.confirm) return setError("Passwords do not match");
    if (f.password.length < 6) return setError("Password must be at least 6 characters");
    setBusy(true); setError("");
    try { await register(f.name, f.email, f.password); nav("/"); } catch (err) { setError(formatApiError(err)); } finally { setBusy(false); }
  };

  return (
    <AuthLayout title="Begin your journey" subtitle="One sanctuary for grading, mixing, scoring and animation.">
      <form onSubmit={submit} className="space-y-5" data-testid="signup-form">
        <div><FieldLabel htmlFor="name">Name</FieldLabel>
          <Input id="name" value={f.name} onChange={set("name")} className="h-11 bg-[#0a0816] border-[#2d2650] mystic-input" data-testid="signup-name-input" /></div>
        <div><FieldLabel htmlFor="email">Email</FieldLabel>
          <Input id="email" type="email" required value={f.email} onChange={set("email")} className="h-11 bg-[#0a0816] border-[#2d2650] mystic-input" data-testid="signup-email-input" /></div>
        <div><FieldLabel htmlFor="password">Password</FieldLabel>
          <PasswordInput id="password" required value={f.password} onChange={set("password")} testId="signup-password-input" /></div>
        <div><FieldLabel htmlFor="confirm">Confirm password</FieldLabel>
          <PasswordInput id="confirm" required value={f.confirm} onChange={set("confirm")} testId="signup-confirm-input" /></div>
        <FormError error={error} />
        <Button type="submit" disabled={busy} className="w-full h-11 mystic-btn text-[#0B0C10] font-semibold tracking-wide" data-testid="signup-submit-button">
          {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Create account
        </Button>
        <p className="text-sm text-slate-400 text-center">Already have an account? <Link to="/login" className="text-[#FFB800] hover:underline" data-testid="goto-login-link">Sign in</Link></p>
      </form>
    </AuthLayout>
  );
}
